
export const toPercentage = (value)=>{
  if(typeof(value)!=='number' && typeof(value)!=='string'){
    return '-'
  }
  let numValue = parseFloat(value).toFixed(4);
  return numValue.toString() + '%';
}

export const toCurrency = (value)=>{
  if (typeof value === 'string'){
    value = value.replaceAll(',','');
    console.log('toCurrencyhere', value);
  }
  return Number(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export const isValidEmail = email => {
  const regex = /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
  return regex.test(email);
}

/*
  Date helpers
 */

//Format - yyyy-mm-dd
export const strToDate = dateStr => {
  const split = dateStr.split('/')
  return new Date(split[2], split[0]-1, split[1]);
}

/*
  Get current date
*/
export const dateToday = () => {
  const today = new Date();
  today.setDate(today.getDate() + 1);
  return [
    today.getFullYear(),
    ('0'+parseInt(today.getMonth()+1).tostring()).slice(-2)
  ].join('-');
}

export const dateBetween = (start, end, d) => {
  return d >= start && d <= end;
}

export const remainingDays = (start, end) => {
  // To calculate the time difference of two dates
  let diff = end.getTime() - start.getTime();
  // To calculate the no. of days between two dates
  return Math.round(diff / (1000 * 3600 * 24)) + 1;
}

export const formatDateTime = (dateStr) => {
  if(dateStr){
    console.log(dateStr);
    const d = new Date(dateStr.replace(/\s/, 'T'));
    const year = d.getFullYear().toString();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    const hour = d.getHours().toString().padStart(2,'0');
    const minutes = d.getMinutes().toString().padStart(2, '0');
    return `${month}/${day}/${year} ${hour}:${minutes}`;
  }
  return '';
}

export const formatDate = (dateStr) => {
  if(dateStr) {
    const d = new Date(dateStr);
    const year = d.getFullYear().toString();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    return `${month}/${day}/${year}`;
  }
  return '';
}

/*
  Array Slicer
 */
export const batch = (array, size) => {
  if (!array) return [];
  const firstChunk = array.slice(0, size); // create the first chunk of the given array
  if (!firstChunk.length) {
    return array; // this is the base case to terminal the recursive
  }
  return [firstChunk].concat(batch(array.slice(size, array.length), size));
}
